import { DependencyList, useLayoutEffect, useState } from 'react';

import { useElementResize } from '../use-element-resize';

export const useHiddenElementsCount = <T>(data: T[] = [], enabled = true, deps?: DependencyList) => {
  const [visibleCount, setVisibleCount] = useState<number | null>(null);

  const { ref, clientWidth } = useElementResize([data]);

  useLayoutEffect(() => {
    const children = Array.from(ref.current?.children || []) as HTMLElement[];

    if (!children.length) {
      return setVisibleCount(0);
    }

    if (!enabled) {
      return setVisibleCount(data.length);
    }

    const firstLineTop = children[0].offsetTop;
    const firstWrappedIdx = children.findIndex((el) => el.offsetTop > firstLineTop);
    const count = firstWrappedIdx > -1 ? firstWrappedIdx : children.length;

    setVisibleCount(count);
  }, [clientWidth, data, enabled, ...(deps || [])]);

  const hiddenCount = visibleCount !== null ? Math.max(data.length - visibleCount, 0) : null;

  return { ref, visibleCount, hiddenCount, ready: visibleCount !== null && visibleCount !== 0 };
};
